import React from 'react';
import { Stack, Typography, CircularProgress, Button, Box } from '@mui/joy';
import PositionCard from './PositionCard';

interface PositionsListProps {
  positions: any[];
  loading: boolean;
  error: string | null;
  page: number;
  hasMore: boolean;
  onLoadMore: () => void;
}

const PositionsList: React.FC<PositionsListProps> = ({
  positions,
  loading,
  error,
  page,
  hasMore,
  onLoadMore
}) => {
  if (loading && page === 1) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="danger" sx={{ mb: 2 }}>
        {error}
      </Typography>
    );
  }

  if (positions.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 6 }}>
        <Typography level="h4" sx={{ mb: 2, color: 'neutral.500' }}>
          No positions found
        </Typography>
        <Typography level="body-md" sx={{ color: 'neutral.600' }}>
          You haven't created any posts yet.
        </Typography>
      </Box>
    );
  }

  return (
    <Stack spacing={3}>
      {positions.map(position => (
        <PositionCard key={position.id} position={position} />
      ))}
      
      {hasMore && !loading && (
        <Button onClick={onLoadMore} variant="outlined" sx={{ mt: 2 }}>
          Load More
        </Button>
      )}
      
      {loading && page > 1 && (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
          <CircularProgress size="sm" />
        </Box>
      )}
    </Stack>
  );
};

export default PositionsList; 